import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixed',
})
export class ToFixedPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    return typeof value === 'number' ? value.toFixed(2) : value;
  }
}
